import { useAccount } from 'wagmi';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ConnectGate = ({ children }) => {
  const { t } = useTranslation();
  const { isConnected } = useAccount();

  if (isConnected) return children;

  return (
    <div className="db-connect-gate">
      <div className="dot-grid dot-grid--subtle" />
      <div className="db-connect-gate__card">
        <div className="db-connect-gate__logo" aria-hidden="true">
          <svg viewBox="0 0 32 32" width="44" height="44">
            <defs>
              <linearGradient id="dbLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FFD56B" />
                <stop offset="100%" stopColor="#E0A820" />
              </linearGradient>
            </defs>
            <polygon
              points="16,2 28,9 28,23 16,30 4,23 4,9"
              fill="none"
              stroke="url(#dbLogoGrad)"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <text
              x="16"
              y="22"
              textAnchor="middle"
              fontFamily="Inter, sans-serif"
              fontSize="16"
              fontWeight="900"
              fill="url(#dbLogoGrad)"
            >
              S
            </text>
          </svg>
        </div>
        <h2>{t('dashboard.gate.title')}</h2>
        <p>{t('dashboard.gate.desc')}</p>
        <div className="db-connect-gate__btn">
          <ConnectButton />
        </div>
        <Link to="/" className="db-connect-gate__back">
          <i className="fas fa-arrow-left" />
          {t('dashboard.gate.backHome')}
        </Link>
      </div>
    </div>
  );
};

export default ConnectGate;
